interface Props {
  inline?: boolean;
  class?: string;
}

export function LoadingSpinner(props: Props) {
  return (
    <div
      class={props.class ?? ""}
      classList={{
        "d-inline": props.inline === undefined,
      }}
    >
      <div class="spinner-border spinner-border-sm ms-1" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
